import { GridSortItem } from '@mui/x-data-grid';
import { useGetProjectWorkbenchesQuery } from '~/api/v2/hooks';
import { TableFilters } from '~/components/Table/components/filters/types';
import { WorkbenchFiltersType } from '~/pages/ProjectDetailsPage/tabs/WorkbenchTab/types';

interface GetWorkbenchesQuery {
  projectId: number;
  showTerminated: boolean;
  searchQuery: string;
  filters: TableFilters;
  sortModel: GridSortItem | null;
}

const useGetWorkbenchesQuery = ({
  projectId,
  showTerminated,
  searchQuery,
  sortModel,
  filters,
}: GetWorkbenchesQuery) => {
  return useGetProjectWorkbenchesQuery(
    {
      projectId,
      search: searchQuery,
      sort: sortModel?.field === 'type' ? 'instance_type' : sortModel?.field,
      order: sortModel?.sort,
      statusList: filters[WorkbenchFiltersType.STATUS].map((filter) => filter.id),
      showTerminated: showTerminated,
      typeList: filters[WorkbenchFiltersType.TYPE].map((filter) => filter.id),
      createdBy: filters[WorkbenchFiltersType.CREATED_BY].map((filter) => filter.id),
      createdOn: filters[WorkbenchFiltersType.CREATED_ON].map((filter) => filter.id),
    },
    { skip: !projectId },
  );
};

export default useGetWorkbenchesQuery;
